import close from "@/assets/images/icons/close.svg"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { Swiper, SwiperSlide } from "swiper/react"
import type { SwiperRef } from "swiper/react"
import FacebookVideo from "./components/FacebookVideo"
import YoutubeVideo from "./components/YoutubeVideo"
import FeedVideo from "./components/FeedVideo"
import type { VideoContent } from "@/service/api/video"
import { useRef, useState } from "react"
import "swiper/css"

const VideoDetail = () => {
  const { id } = useParams<{ id: string }>()
  const parsedId = id ? Number(id) : 0

  const navigate = useNavigate()
  const location = useLocation()
  const videoList = location.state?.videoList
  const swiperRef = useRef<SwiperRef>(null)
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0)

  const initialIndex = videoList.findIndex(
    (item: VideoContent) => item.id === parsedId
  )

  const handleSlideChange = (swiper: any) => {
    setCurrentSlideIndex(swiper.activeIndex)
  }

  return (
    <div className="flex fixed inset-0 justify-center z-100">
      <div className="min-w-[360px] max-w-[768px] w-full min-h-screen bg-black/90">
        <div className="flex justify-between items-center p-4">
          <button onClick={() => navigate(-1)} className="cursor-pointer">
            <img src={close} alt="Close Icons" />
          </button>
        </div>

        <div className="h-[90vh] flex items-center justify-center">
          <Swiper
            ref={swiperRef}
            className="p-3 w-full h-full"
            initialSlide={initialIndex >= 0 ? initialIndex : 0}
            spaceBetween={50}
            slidesPerView={1}
            onSlideChange={handleSlideChange}
            allowTouchMove={true}
            grabCursor={true}
            nested={true}
          >
            {videoList.map((item: VideoContent, index: number) => {
              const isYoutube = item.videoUrl?.includes("youtube")
              const isFacebook = item.videoUrl?.includes("facebook")
              const isFeed = item.videoUrl?.includes("cloudfront")
              const isShown = index === currentSlideIndex

              return (
                <SwiperSlide key={item.id} style={{ touchAction: "pan-y" }}>
                  <div className="flex overflow-hidden justify-center items-center w-full aspect-square bg-black/80">
                    {isYoutube && (
                      <YoutubeVideo
                        embedUrl={item.videoUrl}
                        isShown={isShown}
                      />
                    )}
                    {isFacebook && (
                      <FacebookVideo
                        embedUrl={item.videoUrl}
                        isShown={isShown}
                        thumbImageUrl={item.thumbImageUrl}
                      />
                    )}
                    {isFeed && (
                      <FeedVideo video={item.videoUrl} isShown={isShown} />
                    )}
                  </div>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </div>
      </div>
    </div>
  )
}

export default VideoDetail
